import { Component, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../../../services/api.service';

@Component({
  selector: 'ngx-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LoginComponent {


  redirectDelay = 1500;
  showMessages = {
    success: true,
    error: true,
  };

  strategy = 'email';

  errors: string[] = [];
  messages: string[] = [];
  submitted = false;

  // Nebular’s login user object
  user: any = {
    email: '',
    password: '',
    rememberMe: false
  };

  // Just to avoid template errors
  socialLinks = [];
  rememberMe = true;

  constructor(
    private api: ApiService,
    private router: Router
  ) { }

  //   ngOnInit() {
  //   const token = localStorage.getItem('token');
  //   if (token) {
  //     this.router.navigate(['/pages/dashboard']);  // already logged in
  //   }
  // }

  // Nebular-style getter
  getConfigValue(key: string) {
    return {
      'forms.validation.email.required': true,
      'forms.validation.password.required': true,
      'forms.validation.password.minLength': 4,
      'forms.validation.password.maxLength': 20,
    }[key];
  }

  login() {
    this.errors = [];
    this.messages = [];
    this.submitted = true;

    const payload = {
      email: this.user.email,
      password: this.user.password
    };

    this.api.adminLogin(payload).subscribe({
      next: (res: any) => {
        if (!res.success) {
          this.errors = [res.message || 'Login failed'];
          this.submitted = false;
          return;
        }

        localStorage.setItem('authToken', res.data.token);

        this.messages = ['Login successful'];

        // redirect securely
        this.router.navigate(['/pages/layout/category'], { replaceUrl: true });

        this.submitted = false;
      },

      error: (err) => {
        this.errors = [err.error?.message || 'Login failed'];
        this.submitted = false;
      }
    });
  }

}
